<template>
  <div ref="myEcharts" :style="{ height, width }"></div>
</template>
<script>
import { ref, onMounted } from "vue";
import * as echarts from "echarts";
export default {
  name: "baseBar",
  props: {
    width: {
      type: String,
      default: "100%",
    },
    height: {
      type: String,
      default: "100%",
    },
    right1Data: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    // console.log(props);
    const myEcharts = ref(null);
    const chart = new InitChart(props, myEcharts);
    onMounted(() => {
      chart.init(props.right1Data);
    });
    return {
      myEcharts,
    };
  },
};
class InitChart {
  constructor(props, myEcharts) {
    this.props = props;
    this.myEcharts = myEcharts;
    this.state = {
      chart: null,
    };
  }

  init(right1Data) {
    this.state.chart && this.destory();
    this.state.chart = echarts.init(this.myEcharts.value);

    var color1 = ["#02E8F3","#8609E9","#02E8F3","#8609E9","#02E8F3"]
    var color2 = ["#082638","#101431","#082638","#101431","#082638"]
    const yData1 = [26, 28, 42]
    const yData2 = [32, 36, 50]
    const yData3 = [40, 48, 60]
    this.state.chart.setOption({
    //   tooltip: {
    //     trigger: 'axis',
    //     axisPointer: {
    //       type: 'shadow'
    //     }
    // },
    legend: {
        show:false,
        itemWidth: 10,
        itemHeight: 10,
        top: '2%',
        left: 'center',
        icon: 'rect'
    },
    grid: {
      show:false,
        bottom: '8%',
        left: '0%',
        right: '4%',
        containLabel: true
    },
    xAxis: {
        data: ['2021年', '2022年', '2023年'],
        axisTick: {
        show: false
        },
        axisLabel: {
          interval: 0,
          rotate: 0,
          fontSize: 26,
          color:"#fff"
        }
    },
    yAxis: {
        name:"单位(亿)",
        type: 'value',
        nameTextStyle: {
            align: 'left', // 对齐方式
            verticalAlign: 'top' ,// 垂直对齐方式
            color:"rgba(255,255,255,.8)",
            fontSize: 24,
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(255,255,255,.2)',
            width: 1,
            type: 'solid'
          }
        },
        axisLabel: {
          fontSize: 24,
          color:"rgba(255,255,255,.8)"
        },
    },
    series:[
      {
        name: '注册资本',
        type: 'bar',
        barWidth: '14%',
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#2AE604"
              },
              {
                  offset: 1,
                  color:"#112534"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
          }
        },
        data: yData1
      },
      {
        name: '注册资本',
        type: 'bar',
        barWidth: '14%',
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#810BE3"
              },
              {
                  offset: 1,
                  color:"#112534"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
          }
        },
        data: yData2
      },
      {
        name: '注册资本',
        type: 'bar',
        barWidth: '14%',
        barGap:"0.6",
        itemStyle: {
          color:new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              {
                  offset: 0,
                  color:"#01EDF7"
              },
              {
                  offset: 1,
                  color:"#0D2C3C"
              }
            ])
        },
        label: {
          normal: {
            show: true,
            position: 'top',
            fontSize: 24,
            color:"#fff",
          }
        },
        data: yData3
      },
    ] 
    });
    window.addEventListener("resize", () => {
      this.state.chart.resize();
    });
  }

  destory() {
    this.state.chart.dispose();
    window.removeEventListener("resize", () => {
      console.log("事件移除");
    });
  }
}
</script>
<style lang="less"></style>
